import { SidepanelDefaultRowTypes } from './types';

import styles from './side-panel-default-row.module.css';

export default function SidepanelDefaultRow({
  title,
  children,
  wrapperClassName,
  titleClassName,
  valueClassName,
}: SidepanelDefaultRowTypes): React.JSX.Element {
  return (
    <div className={`${styles.sidepanelDefaultRow} ${wrapperClassName || ''}`}>
      {title && (
        <div
          className={`${styles.sidepanelDefaultRowTitle} ${
            titleClassName || ''
          }`}
        >
          {title}
        </div>
      )}
      <div
        className={`${styles.sidepanelDefaultRowValue} ${valueClassName || ''}`}
      >
        {children}
      </div>
    </div>
  );
}
